import { TipoCredorComissoesEntidade, TipoCredorComissoesEntidadeLabel } from '../../../../enums/pessoa-enums/credor-comissoes/tipo-credor-comissoes-entidade.enum';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PessoaService } from 'src/app/services/pessoa.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { Observable, Subject } from 'rxjs';
import { ResultadoModal } from 'src/app/services/shared/resultado-modal';
import { LocalDataSource } from 'ng2-smart-table';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { DocumentoService } from 'src/app/services/documento.service';
import { Guid } from 'guid-typescript';
import { Tipo } from 'src/app/enums/documento/tipo.enum';
import { CustomInputEditorNg2Component } from 'src/app/views/shared/custom-input-editor-ng2/custom-input-editor-ng2/custom-input-editor-ng2.component';
import { AuthService } from 'src/app/auth/auth.service';
import { Pessoa, PessoaDados, PessoaDadosComplementares } from 'src/app/models/pessoa/pessoa';
import { PessoaMapeamentoChaves } from 'src/app/models/pessoa/pessoa-mapeamento-chaves';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Modulo } from 'src/app/enums/modulo.enum';
import Swal from 'sweetalert2';
import { SalarioService } from 'src/app/services/salario.service';
import { NaturezaPessoa } from 'src/app/enums/pessoa-enums/natureza-pessoa.enum';
import { CategoriaPessoaJuridica } from 'src/app/enums/pessoa-enums/categoria-pessoa-juridica.enum';
import { obterConfiguracaoDadosAdicionais } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-campos-adicionais';
import { obterConfiguracaoArquivos } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-arquivos';
import { obterConfiguracaoBancos } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-bancos';
import { obterConfiguracaoEnderecos } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-enderecos';
import { obterConfiguracaoTelefones } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-telefones';
import { obterConfiguracaoComissoesCobradorValores, obterConfiguracaoComissoesPrivadasDias, obterConfiguracaoComissoesPrivadasValores, obterConfiguracaoComissoesPublicasDias, obterConfiguracaoHistoricoComissoes } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-comissoes';
import { obterConfiguracaoHonorarios } from 'src/app/configs/smart-table/cadastro-pessoa/configuracao-honorarios';
import { formatarValorParaReal } from 'src/app/utils/formata-valor';

@Component({
    selector: 'app-modal-novo-cadastro-pessoa',
    templateUrl: './modal-novo-cadastro-pessoa.component.html',
    styleUrls: [
        '../../../../../vendor/styles/pages/dropzone.scss',
        'modal-novo-cadastro-pessoa.component.css',
        '../../../../../vendor/libs/ng2-smart-table/ng2-smart-table.scss'
    ],
    providers: [PessoaService, DadosCargasService]
})
export class ModalNovoCadastroPessoaComponent implements OnInit, AfterViewInit {

    constructor(
        private pessoaService: PessoaService,
        private dadosCargasService: DadosCargasService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        public utilsService: UtilsService,
        private documentoService: DocumentoService,
        private authService: AuthService,
        private salarioMinimoService: SalarioService
    ) {

        this.uploader = new FileUploader({
            url: pessoaService.postFileUrl,
            disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
            formatDataFunctionIsAsync: true,
            formatDataFunction: async (item) => {
                //TODO: Adicionei o <void>, testar se tem algum problema em fazer isso
                return new Promise<void>((resolve, reject) => {
                    resolve();
                });
            }
        });

        this.hasBaseDropZoneOver = false;
        this.hasAnotherDropZoneOver = false;
        this.response = '';
        this.uploader.response.subscribe(res => this.response = res);

    }

    ngAfterViewInit(): void {
        if(this.unidadeNegocio || this.grupo){
            this.pessoa2.naturezaPessoa = NaturezaPessoa.Juridica;
                        
            this.pessoa2.categoriaPessoaJuridica = this.unidadeNegocio ? CategoriaPessoaJuridica.UnidadeNegocio : CategoriaPessoaJuridica.Grupo;

            this.pessoa2.tipo = 'Credor';
        }
    }

    resultConfirmDialog$ = new Subject<ResultadoModal>();

    modalRef: NgbModalRef;
    cadastrandoCampo = false;
    unidadeNegocio = false;
    grupo = false;

    //TODO: Migrar para um arquivo de mascaras
    public maskTime = [/\d/, /\d/, ':', /\d/, /\d/]

    get ehPessoaJuridica(): boolean {
        return Number(this.pessoa2?.naturezaPessoa) === NaturezaPessoa.Juridica;
    }

    get labelDocumento(): String {
        return this.ehPessoaJuridica ? "CNPJ" : "CPF";
    }

    get informaDocumento(): boolean {
        if(!this.ehPessoaJuridica) return true;

        const categoriasPJQueInformamCnpj = [CategoriaPessoaJuridica.Matriz, CategoriaPessoaJuridica.Filial, CategoriaPessoaJuridica.OrgaosEEntePublico];
        return categoriasPJQueInformamCnpj.includes(Number(this.pessoa2?.categoriaPessoaJuridica));
    }

    get informaUnidadeNegocioInformacaoCadastro(): boolean {
        if(!this.ehPessoaJuridica) return false;

        const categoriasPJQueInformamUnidadeNegocio = [CategoriaPessoaJuridica.Matriz, CategoriaPessoaJuridica.Filial, CategoriaPessoaJuridica.OrgaosEEntePublico];
        return categoriasPJQueInformamUnidadeNegocio.includes(Number(this.pessoa2?.categoriaPessoaJuridica));
    }

    get informaGrupoInformacaoCadastro(): boolean{
        if(!this.ehPessoaJuridica) return false;

        return CategoriaPessoaJuridica.Grupo !== Number(this.pessoa2?.categoriaPessoaJuridica);
    }

    tituloModal: String = '';

    public bancos: any[] = [];
    public telefones: any[] = [];
    public camposAdicionais: any[] = [];
    public enderecos: any[] = [];
    public superiores: any[] = [];
    public tiposComissoes: any[] = [];

    public settingsBancos: any;
    public settingsSuperiores: any;
    public settingsTelefones: any;
    public settingsEnderecos: any;
    public configuracaoCamposAdicionais: any;

    public settingsComissoesPrivadoValores: any;
    public settingsComissoesPublicoValores: any;
    public settingsComissoesPrivadoDias: any;
    public settingsComissoesPublicoDias: any;
    public settingsHistoricoComissoes: any;

    public settingsHonorariosJDValores: any;
    honorariosJDPrivadoValoresInitialFee = [];
    honorariosJDPublicoValoresInitialFee = [];

    honorariosJDPrivadoValoresSuccessFee = [];
    honorariosJDPublicoValoresSuccessFee = [];

    public settingsComissoesCobradorValores: any;

    public settingsArquivos;

    public tiposPessoas = [];
    public listaBancos = [];
    public listaEstados = [];
    public tiposTelefones = [];
    public tipoEstadoCivil = [];
    public tipoRegimeDeBens = [];
    public tiposCobrador = [];
    public tiposEntidade = [];
    public situacoesCliente = [];
    public tiposCliente = [];
    public calcularHonorarioCliente = [];
    public naturezasPessoa = [];
    public categoriasPessoaJuridica = [];    

    public files: File[] = [];
    public isHovering: boolean;
    public uploader: FileUploader;
    public hasBaseDropZoneOver: boolean;
    public hasAnotherDropZoneOver: boolean;
    public response: string;

    file: File;
    arquivos: any[] = [];
    source: LocalDataSource;
    tipoDocumentos = [];


    credorComissoesComVigenciaAtiva = [];
    tipoComissao = '0';
    comissoesPrivadoValores = [];
    comissoesPublicoValores = [];
    comissoesPrivadoDias = [];
    comissoesPublicoDias = [];

    credorComissoesHistorico = [];
    credorComissoesHistoricoDias = [];
    credorComissoesHistoricoValor = [];

    abaAtiva = 1;


    permitirParcelamento = true;
    permitirParcelamentoJuridico = true;
    politica = true;
    politicaJuridico = true;
    checarAcordo = true;
    checarAcordoJuridico = true;
    calcularHonorarios = true;

    modoSomenteLeitura: Boolean = false;

    pessoa2: Pessoa = new Pessoa();
    pessoaMap: PessoaMapeamentoChaves;


    //leitura e gravacao dados tabelas ng
    bancosPessoa: PessoaDados[] = [];
    bancosPessoaNG: any[] = [];

    telefonesPessoa: PessoaDados[] = [];
    telefonesPessoaNG: any[] = [];

    camposAdicionaisPessoa: PessoaDados[] = [];
    camposAdicionaisPessoaNG: any[] = [];

    enderecosPessoa: PessoaDados[] = [];
    enderecosPessoaNG: any[] = [];

    comissoesCobradorPessoa: PessoaDados[] = [];
    comissoesCobradorPessoaNG: any[] = [];
    //leitura e gravacao dados tabelas ng


    grupos: any[] = [];

    isCredor: Boolean;
    isMaster: Boolean;
    public loading: Boolean = false;
    dadosUnico: any[];
    listaUnidadesNegocio: any[] = [];
    listaGrupos: any[] = [];

    isUpdateContato: Boolean = false;

    public isDisableSave: boolean = false;

    public valorSalarioCorrente: number=0;

    async ngOnInit(): Promise<void> {
        this._definirTituloModal();
        this._popularDropdownsPessoasPorCategorias();

        this.obterValorSalario();

        if (this.modalRef.componentInstance.updateData) {
            this.loading = true;
            await this.checkPessoaIfExists(this.modalRef.componentInstance.pessoa.id);
        }

        if (this.modalRef.componentInstance.updateDataContato != undefined
            && this.modalRef.componentInstance.updateDataContato) {
            this.isUpdateContato = true;
        }

        this.getTiposDocumento();

        this.isMaster = this.authService.isMaster();
        this.isCredor = this.authService.isPermissionAvailable(Modulo.OPERACIONAIS_PROCESSOS_CREDOR);


        this.pessoaService.getAllGroups().subscribe(x => {
            x.data.forEach(element => {
                this.grupos.push(element.grupo)
            });
            const newArr = this.grupos.map(x => x.toLocaleLowerCase());
            this.dadosUnico = newArr.filter((el, i, arr) => arr.indexOf(el.toLocaleLowerCase()) == i);

        })

        this.pessoaService.getPessoaMapeamentoChaves().subscribe(x => {
            this.pessoaMap = x.data;
            if (!this.modalRef.componentInstance.updateData) {

                this.pessoa2 = new Pessoa();
                this.startLists();
                this.loading = false;
                this.spinner.hide();

            } else {
                this.loading = true;
                this.pessoaService.getById(this.modalRef.componentInstance.pessoa.id).subscribe(x => {

                    this.pessoa2 = x.data;
                    this.startLists();

                    this._carregarDadosIniciais();
                    this.getCredorComissoes(this.pessoa2.id);
                    this.getArquivosPessoa();

                    this.checks();

                    this.loading = false;

                    this.calcularSalario();
                    this.calcularSalarioPublico();
                    this.spinner.hide();
                })
            }

        });

        this.tiposPessoas = this.dadosCargasService.getipoPessoas();
        this.camposAdicionais = this.dadosCargasService.mockCamposAdicionais();
        this.listaBancos = this.dadosCargasService.mockBancos();
        this.tiposTelefones = this.dadosCargasService.mockTelefones();
        this.listaEstados = this.dadosCargasService.mockEstados();
        this.tiposComissoes =
        this.tipoEstadoCivil = this.pessoaService.getTipoEstadoCivil();
        this.tipoRegimeDeBens = this.pessoaService.getTipoRegimeBens();
        this.tiposCobrador = this.pessoaService.getTipoCobrador();
        this.tiposEntidade = this.pessoaService.getTipoEntidade();
        this.situacoesCliente = this.pessoaService.getSituacaoCredor();
        this.tiposCliente = this.pessoaService.getTipoCredor();
        this.calcularHonorarioCliente = this.pessoaService.getCalcularHonorarioCredor();
        this.naturezasPessoa = this.pessoaService.obterNaturezasPessoa();
        this.categoriasPessoaJuridica = this.pessoaService.obterCategoriasPessoaJuridica();

        this.popularSettingsTabelas();
        this._verificarModoSomenteLeitura();

        //[Obsoleto("Remover quando remover o campo, só para iniciar com valor")]
        this.pessoa2.tipo = 'Credor';
    }
    
    obterValorSalario() {
        this.salarioMinimoService.obterUltimo().subscribe(res=>{
            this.valorSalarioCorrente = res.data.valor;
        })
    }

    //TODO: Renomear método, entender melhor os campos e renomear
    checks() {
        this.permitirParcelamento = this.checkPermitirParcelamento();
        this.permitirParcelamentoJuridico = this.checkPermitirParcelamentoJuridico();
        this.politica = this.checkPolitica();
        this.politicaJuridico = this.checkPoliticaJuridico();
        this.checarAcordo = this.checkChecarParametrosAoGerarAcordo();
        this.checarAcordoJuridico = this.checkChecarParametrosAoGerarAcordoJuridico();
        this.calcularHonorarios = this.checkTaxaAdministrativa();
    }

    popularSettingsTabelas() {
        this.settingsArquivos = obterConfiguracaoArquivos();
        //TODO: Avaliar esse columns, acho que dá pra levar lá pro arquivo de configuração
        this.settingsArquivos.columns = {
            nome: {
                 title: 'Nome do Arquivo',
                 filter: false,
                 width: '65%'
            },
            tipoDocumento: {
                    title: 'Tipo do Documento',
                    filter: false,
                    width: '35%',
                    valuePrepareFunction: (cell, row) => this.getDescricaoTipoArquivo(cell, row)
            }
        };
        this.settingsBancos = obterConfiguracaoBancos(this.listaBancos);
        this.settingsEnderecos = obterConfiguracaoEnderecos(this.listaEstados);
        this.settingsTelefones = obterConfiguracaoTelefones(this.tiposTelefones);
        this.configuracaoCamposAdicionais = obterConfiguracaoDadosAdicionais(this.camposAdicionais);
        this.settingsComissoesPrivadoValores = obterConfiguracaoComissoesPrivadasValores();
        this.settingsHonorariosJDValores = obterConfiguracaoHonorarios();
        this.settingsComissoesPrivadoDias = obterConfiguracaoComissoesPrivadasDias();
        this.settingsComissoesPublicoDias = obterConfiguracaoComissoesPublicasDias();
        this.settingsComissoesCobradorValores = obterConfiguracaoComissoesCobradorValores();
        this.settingsHistoricoComissoes = obterConfiguracaoHistoricoComissoes();
    }

    cadastrar() {
        this.addLists();
        this.montarComissoesParaUpdate();
        
        if(this.pessoa2.cpfCnpj){
            var cpfCnpj = this.utilsService.mascaraCpfCnpjCadastro(this.pessoa2.cpfCnpj);
            this.pessoa2.cpfCnpj = cpfCnpj;
        }

        if(!this._validarCadastroPessoa(this.pessoa2)) return;

        if (this.modalRef.componentInstance.updateData) {
            this.update(this.pessoa2)
        } 
        else {
            this.add(this.pessoa2);
        }
    }

    onDeleteConfirm(event) {

        if (window.confirm('Você quer mesmo deletar esse registro ?')) {
            const index = event.source.data.indexOf(event.data);
            event.source.data.splice(index, 1);
            event.confirm.resolve();
        } else {
            event.confirm.reject();
        }
    }

    onCreateEditHonorarioJD(event){
        if(event){
            if(+event.newData['valor'] == 0 && +event.newData['percentual']==0){
                this.toastrService.error('Informe o percentual ou o valor!', 'Atenção', { timeOut: 10000 });
                event.confirm.reject();
                return;
            }

            if(+event.newData['valor'] > 0){
                event.newData['percentual']=0;
            }

            event.confirm.resolve(event.newData);
        }
    }

    onDeleteConfirmComissao(event) {

        if (window.confirm('Você quer mesmo deletar essa comissão ?')) {
            const index = event.source.data.indexOf(event.data);
            event.source.data.splice(index, 1);
            event.confirm.resolve();
            if (this.pessoa2.id != null && this.pessoa2.id != undefined) {
                this.deleteCredorComissoes(this.pessoa2.id, event.data.id)
            }
        } else {
            event.confirm.reject();
        }
    }

    onDeleteConfirmHonorariosJD(event) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-padrao btn-lg mr-3',
                cancelButton: 'btn btn-default btn-lg'
            },
            buttonsStyling: false
        });

        swalWithBootstrapButtons.fire({
            text: 'Deseja realmente excluir?',
            confirmButtonColor: '#FFD950 !important;',
            showCloseButton: true,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                const index = event.source.data.indexOf(event.data);
                event.source.data.splice(index, 1);
                event.confirm.resolve();
                if (this.pessoa2.id != null && this.pessoa2.id != undefined) {
                    this.deleteCredorComissoes(this.pessoa2.id, event.data.id)
                    //aqui vai remover
                }
            } else {
                event.confirm.reject();
            }
        });
    }


    getArquivosPessoa() {
        this.pessoaService.getAllArquivos(this.pessoa2.id)
            .subscribe(result => {

                this.source = new LocalDataSource(result.data);


            }, error => {
                if (error && error.errors) {
                    error.errors.forEach(element => {
                        this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                    });
                } else {
                    this.toastrService.error('Não foi possível obter os arquivos da pessoa!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    

    private _validarCadastroPessoa(pessoa) {

        if(!this._validarDocumentosAnexados())
            return false;
        
        if (pessoa.nome == null || pessoa.nome == undefined || pessoa.nome == '' || pessoa.nome.length <= 2) {
            this.toastrService.error('Nome da pessoa inválido.', 'Erro');
            return false;
        }

        if (pessoa.email == null || pessoa.email == undefined || pessoa.email == '') {
            this.toastrService.error('E-mail da pessoa inválido', 'Erro');
            return false;
        }

        if (this.informaDocumento && (pessoa.cpfCnpj == null || pessoa.cpfCnpj == undefined || pessoa.cpfCnpj == '')) {
            this.toastrService.error('CPF ou CNPJ inválido.', 'Erro');
            return false;
        }

        if((this.unidadeNegocio || this.grupo) && !pessoa.nickname){
            this.toastrService.error('Informe o Nickname.', 'Erro');
            return false;
        }

        return true;
    }

    add(pessoa) {
        this.spinner.show();
        this.toastrService.clear();

        this.pessoaService.add(this.pessoa2)
            .subscribe(async res => {

                this.pessoa2.id = res.data.id;

                if (!this.updateCredorComissoes(pessoa.id, this.credorComissoesComVigenciaAtiva)) {
                    this.toastrService.error('Comissoes não foram salvas corretamente', 'Erro');
                };

                await this.enviarArquivos().subscribe(x => {

                }, erro => { });

                this.spinner.hide();
                this.toastrService.success("Pessoa cadastrada.", "Successo");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });

            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar a pessoa!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    update(pessoa) {


        this.spinner.show();
        this.toastrService.clear();

        this.pessoaService.update(this.pessoa2)
            .subscribe(async res => {

                if (!this.updateCredorComissoes(pessoa.id, this.credorComissoesComVigenciaAtiva)) {
                    this.toastrService.error('Comissoes não foram salvas corretamente', 'Erro');
                };

                this.toastrService.success('Pessoa atualizada.', 'Successo');

                await this.enviarArquivos().subscribe(x => {

                }, erro => { });

                this.spinner.hide();
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    error.errors.forEach(element => {
                        this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                    });
                } else {
                    this.toastrService.error('Não foi possível atualizar a pessoa!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }


    // métodos basicos
    cadastrarCampo() {
        this.cadastrandoCampo = true;
    }

    fecharCadastrarCampo() {
        this.cadastrandoCampo = false;
    }

    isCPF(): boolean {
        return this.pessoa2.cpfCnpj == null ? true : this.pessoa2.cpfCnpj.length <= 14 ? true : false;
    }

    getCpfCnpjMask() {
        var cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        var cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

        return this.isCPF() ? cpfMask : cnpjMask;
    }

    switchTipoComissao(event) {
        if (this.tipoComissao == "0") {
            this.tipoComissao = "1";
        }
        else {
            this.tipoComissao = "0";
        }
        //this.pessoa.cliente.tipoComissao =
    }


    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }

    montarComissoesParaUpdate() {
        var credorComissoes = []

        this.comissoesPrivadoValores.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada);
            item.ambiente = "1";
        });

        this.comissoesPublicoValores.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica);
            item.ambiente = "1";
        });

        this.comissoesPrivadoDias.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada);
            item.ambiente = "1";
        });

        this.comissoesPublicoDias.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica);
            item.ambiente = "1";
        });

        credorComissoes.push.apply(credorComissoes, this.comissoesPrivadoValores);
        credorComissoes.push.apply(credorComissoes, this.comissoesPublicoValores);
        credorComissoes.push.apply(credorComissoes, this.comissoesPrivadoDias);
        credorComissoes.push.apply(credorComissoes, this.comissoesPublicoDias);

        this.honorariosJDPrivadoValoresInitialFee.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada);
            item.ambiente = "2";
            item.tipoComissao = "Initial Fee";
        });

        this.honorariosJDPublicoValoresInitialFee.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica);
            item.ambiente = "2";
            item.tipoComissao = "Initial Fee";
        });

        this.honorariosJDPrivadoValoresSuccessFee.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada);
            item.ambiente = "2";
            item.tipoComissao = "Success Fee";
        });

        this.honorariosJDPublicoValoresSuccessFee.forEach(function (item) {
            item.entidade = TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica);
            item.ambiente = "2";
            item.tipoComissao = "Success Fee";
        });

        credorComissoes.push.apply(credorComissoes, this.honorariosJDPrivadoValoresInitialFee);
            credorComissoes.push.apply(credorComissoes, this.honorariosJDPublicoValoresInitialFee);
            credorComissoes.push.apply(credorComissoes, this.honorariosJDPrivadoValoresSuccessFee);
            credorComissoes.push.apply(credorComissoes, this.honorariosJDPublicoValoresSuccessFee);

            credorComissoes.forEach(function (value) {
                value.inicial = isNaN(Number(value.inicial)) ? 0 : Number(value.inicial);
                value.final = isNaN(Number(value.final)) ? 0 : Number(value.final);
                value.percentual = isNaN(Number(value.percentual)) ? 0 : Number(value.percentual);
            });

        this.credorComissoesComVigenciaAtiva = credorComissoes;

    }



    getDescricaoTipoArquivo(cell, row) {
        return this.tipoDocumentos.find(t => t.valor == cell.id).nome;
    }

    getTiposDocumento() {
        this.documentoService.getAllByTipo(Tipo.Pessoa)
            .subscribe(result => {
                this.tipoDocumentos.push({ descricao: '-- Selecione --', nome: 'selecione', valor: Guid.EMPTY })
                result.data.forEach(tipoDocumento => {
                    this.tipoDocumentos.push({ descricao: tipoDocumento.descricao, nome: tipoDocumento.nome, valor: tipoDocumento.id });
                });
            }, error => {
                if (error && error.errors) {
                    error.errors.forEach(element => {
                        this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                    });
                } else {
                    this.toastrService.error('Não foi possível obter os tipos de documento!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    onDrop(event) {
        this.file = event[0];
        const fileInQueue = this.uploader.queue.find(q => q.file.name === this.file.name);
        const newFile = new CustomFileLike(fileInQueue.file);
        newFile.documentType = this.tipoDocumentos[0].valor;
        fileInQueue.file = newFile;
    }

    onTipoDocumentChange(index, customFile) {
        customFile.documentType = this.tipoDocumentos[index].valor;
    }

    enviarArquivos(): Observable<boolean> {
        const envioArquivos = new Observable<boolean>((observer) => {
            const arquivosUpload = [];
            this.uploader.queue.forEach(item => {
                debugger;
                arquivosUpload.push(this.montarFormDataArquivo(item.file));
            });

            arquivosUpload.forEach(arquivo => {
                this.pessoaService.uploadArquivo(arquivo).subscribe(result => {
                    if (result.success) {
                        this.arquivos.push(result.data);
                        this.uploader.clearQueue();
                        this.source.append(result.data);
                        this.toastrService.success(`Arquivo ${result.data.nome} salvo.`, 'Successo');
                        observer.next(true);
                        return;
                    } else {
                        result.data.errors.forEach(element => {
                            this.toastrService.error(element);
                        });
                        observer.error('Houve um erro no envio de arquivos');
                        return;
                    }
                }, error => {
                    if (error && error.errors) {
                        error.errors.forEach(element => {
                            this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                        });
                    } else {
                        this.toastrService.error('Não foi possível enviar o arquivo!', 'Atenção', { timeOut: 10000 });
                    }
                    this.spinner.hide();
                    observer.error('Houve um erro no envio de arquivos');
                    return;
                });
            });
            observer.next(false);
        });

        return envioArquivos;
    }

    montarFormDataArquivo(item: FileLikeObject) {
        const file = item as CustomFileLike;
        const formData: FormData = new FormData();
        formData.append('pessoaId', this.pessoa2.id);
        formData.append('pasta', 'pessoas');
        formData.append('tipoDocumentoId', file.documentType);
        formData.append('nome', file.name);
        formData.append('contentType', file.type);
        formData.append('file', this.file as File);
        return formData;
    }

    onExcluirArquivo($event) {
        if (window.confirm('Confirma a exclusão do arquivo?')) {
            const pessoaId = this.pessoa2.id;
            const arquivoId = $event.data.id;

            this.pessoaService.deleteArquivo(pessoaId, arquivoId).subscribe(result => {
                if (result.success) {
                    this.toastrService.success(`Arquivo excluído.`, 'Successo');
                    $event.confirm.resolve();
                }
            }, error => {
                if (error && error.errors) {
                    error.errors.forEach(element => {
                        this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                    });
                } else {
                    this.toastrService.error('Não foi possível excluir o arquivo!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
        } else {
            $event.confirm.reject();
        }
    }

    updateCredorComissoes(pessoaId, comissoes) {
        return this.pessoaService.updateCredorComissoes(pessoaId, comissoes).subscribe(x => {
            return true;
        }, error => {
            return false;
        })
    }

    getCredorComissoes(pessoaId) {
        this.pessoaService.getCredorComissoes(pessoaId).subscribe(x => {

            this.credorComissoesComVigenciaAtiva = x.data.filter(function vigenciaAtiva(element, index, array) {
                return (element.dataVigenciaFinal == "0001-01-01T00:00:00");
            });

            this.comissoesPrivadoValores = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return ((element.tipoComissao == "Identificacao" || element.tipoComissao == "Pagamento") && element.ambiente == "Amigavel" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada));
            });

            this.comissoesPublicoValores = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return ((element.tipoComissao == "Identificacao" || element.tipoComissao == "Pagamento") && element.ambiente == "Amigavel" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica));
            });

            this.comissoesPrivadoDias = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return ((element.tipoComissao == "Dias do Recebimento" || element.tipoComissao == "Dias de vencido") && element.ambiente == "Amigavel" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada));
            });

            this.comissoesPublicoDias = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return ((element.tipoComissao == "Dias do Recebimento" || element.tipoComissao == "Dias de vencido") && element.ambiente == "Amigavel" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica));
            });

            this.honorariosJDPrivadoValoresInitialFee = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return (element.tipoComissao == "Initial Fee" && element.ambiente == "Juridico" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada));
            });

            this.honorariosJDPublicoValoresInitialFee = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return (element.tipoComissao == "Initial Fee" && element.ambiente == "Juridico" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica));
            });

            this.honorariosJDPrivadoValoresSuccessFee = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return (element.tipoComissao == "Success Fee" && element.ambiente == "Juridico" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Privada));
            });

            this.honorariosJDPublicoValoresSuccessFee = this.credorComissoesComVigenciaAtiva.filter(function getComissoes(element, index, array) {
                return (element.tipoComissao == "Success Fee" && element.ambiente == "Juridico" && element.entidade == TipoCredorComissoesEntidadeLabel.get(TipoCredorComissoesEntidade.Publica));
            });

            this.credorComissoesHistorico = x.data;

            this.credorComissoesHistoricoDias = x.data.filter(function dias(element, index, array) {
                return (element.tipoComissao.includes("Dias"));
            });
            this.credorComissoesHistoricoValor = x.data.filter(function dias(element, index, array) {
                return (!element.tipoComissao.includes("Dias"));
            });
            //credorComissoesHistoricoValor = [];
        }, error => {

        })
    }

    deleteCredorComissoes(pessoaId, id) {
        return this.pessoaService.deleteCredorComissoes(pessoaId, id).subscribe(x => {
            return true;
        }, error => {
            return false;
        })
    }

    politicaDeAcordoDefault() {
        var jurosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.jurosMinimo, this.pessoa2);
        var jurosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.jurosMaximo, this.pessoa2);
        jurosMinimo.valor = '0';
        jurosMaximo.valor = '0';

        var parcelamentoMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);
        var parcelamentoMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);
        parcelamentoMinimo.valor = '1';
        parcelamentoMaximo.valor = '1';
        this.permitirParcelamento = false;

        var politica = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.politica, this.pessoa2);
        politica.valor = 'CDD';


        var checarParamentros = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);
        checarParamentros.valor = 'Nao';
        this.checarAcordo = false;

    }
    politicaDeAcordoDefaultJuridico() {
      var percentualIndiceCorrecao = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
        this.pessoaMap.credorInfoCad.percentualIndiceCorrecao, this.pessoa2);
      var percentualJuros = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.percentualJuros, this.pessoa2);
      var percentualMulta = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.percentualMulta, this.pessoa2);
      var limiteDescontoSobValorAtualizado = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
            this.pessoaMap.credorInfoCad.LimiteDescontoSobValorAtualizado, this.pessoa2);
      limiteDescontoSobValorAtualizado.valor = '0';
      percentualIndiceCorrecao.valor = '0';
      percentualJuros.valor = '0';
      percentualMulta.valor = '0';

      var parcelamentoMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);
      var parcelamentoMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);
      parcelamentoMinimo.valor = '1';
      parcelamentoMaximo.valor = '1';
      this.permitirParcelamentoJuridico = false;

      var politica = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.politica, this.pessoa2);
      politica.valor = 'CDD';


      var checarParamentros = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);
      checarParamentros.valor = 'Nao';
      this.checarAcordoJuridico = false;

  }

    handleChangeParcelamento(evt, tipo) {

        var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);

        var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);

        var target = evt.target;

        if (tipo == 'Sim') {
            this.permitirParcelamento = true;

        }
        if (tipo == 'Não') {
            this.permitirParcelamento = false;
            pessoaDadosMinimo.valor = '1';
            pessoaDadosMaximo.valor = '1';
            // this.pessoa.cliente.parcelamentoMinimo.valor = '1';
            // this.pessoa.cliente.parcelamentoMaximo.valor = '1';
        }

    }
    handleChangeParcelamentoJuridico(evt, tipo) {

      var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
          this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);

      var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
          this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);

      var target = evt.target;

      if (tipo == 'Sim') {
          this.permitirParcelamentoJuridico = true;

      }
      if (tipo == 'Não') {
          this.permitirParcelamentoJuridico = false;
          pessoaDadosMinimo.valor = '1';
          pessoaDadosMaximo.valor = '1';
          // this.pessoa.cliente.parcelamentoMinimo.valor = '1';
          // this.pessoa.cliente.parcelamentoMaximo.valor = '1';
      }

    }

    handleChangePolitica(evt, tipo) {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.politica, this.pessoa2);

        var target = evt.target;


        if (tipo == 'CDD') {
            pessoaDados.valor = 'CDD';
            // this.pessoa.cliente.politica.valor = 'CDD';
        }
        if (tipo == 'Credor') {
            pessoaDados.valor = 'Credor'
            //this.pessoa.cliente.politica.valor = 'Credor';

        }

    }

    handleChangeChecarParametrosAoGerarAcordo(evt, tipo) {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);


        var target = evt.target;

        if (tipo == 'Sim') {
            pessoaDados.valor = 'Sim';

            //permitir parcelamento = nao
            var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
                this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);
            var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
                this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);
            pessoaDadosMinimo.valor = '1';
            pessoaDadosMaximo.valor = '1';
            //

            //politica = credor
            var pessoaDadosPolitica = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
                this.pessoaMap.credorInfoCad.politica, this.pessoa2);
            pessoaDadosPolitica.valor = 'Credor';
            //

            //juros maximo e juros minimo = 0;
            var jurosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
                this.pessoaMap.credorInfoCad.jurosMinimo, this.pessoa2);
            var jurosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
                this.pessoaMap.credorInfoCad.jurosMaximo, this.pessoa2);
            jurosMinimo.valor = '0';
            jurosMaximo.valor = '0';
            //
            this.politica = this.checkPolitica();
            this.permitirParcelamento = this.checkPermitirParcelamento();
            this.checarAcordo = true;


        }
        if (tipo == 'Não') {
            pessoaDados.valor = 'Nao';
            this.checarAcordo = false;

        }

    }

    handleChangeChecarParametrosAoGerarAcordoJuridico(evt, tipo) {

      var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);


      var target = evt.target;

      if (tipo == 'Sim') {
          pessoaDados.valor = 'Sim';

          //permitir parcelamento = nao
          var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);
          var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);
          pessoaDadosMinimo.valor = '1';
          pessoaDadosMaximo.valor = '1';
          //

          //politica = credor
          var pessoaDadosPolitica = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.politica, this.pessoa2);
          pessoaDadosPolitica.valor = 'Credor';
          //

          var percentualIndiceCorrecao = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.percentualIndiceCorrecao, this.pessoa2);
          var percentualJuros = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.percentualJuros, this.pessoa2);
          var percentualMulta = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.percentualMulta, this.pessoa2);
          var limiteDescontoSobValorAtualizado = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
              this.pessoaMap.credorInfoCad.LimiteDescontoSobValorAtualizado, this.pessoa2);
          limiteDescontoSobValorAtualizado.valor = '0';
          percentualIndiceCorrecao.valor = '0';
          percentualJuros.valor = '0';
          percentualMulta.valor = '0';
          //
          this.politicaJuridico = this.checkPoliticaJuridico();
          this.permitirParcelamentoJuridico = this.checkPermitirParcelamentoJuridico();
          this.checarAcordoJuridico = true;


      }
      if (tipo == 'Não') {
          pessoaDados.valor = 'Nao';
          this.checarAcordoJuridico = false;

      }

    }

    checkPermitirParcelamento() {

        var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);

        if (pessoaDadosMinimo.valor == '') {
            pessoaDadosMinimo.valor = '1';
        }

        var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);

        if (pessoaDadosMaximo.valor == '') {
            pessoaDadosMaximo.valor = '1';
        }


        if (pessoaDadosMinimo.valor === '1' && pessoaDadosMaximo.valor === '1') {
            return false;
        }
        return true;
    }
    checkPermitirParcelamentoJuridico() {

      var pessoaDadosMinimo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.parcelamentoMinimo, this.pessoa2);

      if (pessoaDadosMinimo.valor == '') {
          pessoaDadosMinimo.valor = '1';
      }

      var pessoaDadosMaximo = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.parcelamentoMaximo, this.pessoa2);

      if (pessoaDadosMaximo.valor == '') {
          pessoaDadosMaximo.valor = '1';
      }


      if (pessoaDadosMinimo.valor === '1' && pessoaDadosMaximo.valor === '1') {
          return false;
      }
      return true;
    }

    checkPolitica() {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.politica, this.pessoa2);

        if (pessoaDados.valor == '') {
            pessoaDados.valor = 'CDD';
        }

        if (pessoaDados.valor === 'CDD') {
            return true;
        }
        return false;


    }
    checkPoliticaJuridico() {

      var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.politica, this.pessoa2);

      if (pessoaDados.valor == '') {
          pessoaDados.valor = 'CDD';
      }

      if (pessoaDados.valor === 'CDD') {
          return true;
      }
      return false;


  }

    checkChecarParametrosAoGerarAcordo() {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);

        if (pessoaDados.valor == '') {
            pessoaDados.valor = 'Nao';
        }

        if (pessoaDados.valor === 'Sim') {
            return true;
        }
        return false;


    }
    checkChecarParametrosAoGerarAcordoJuridico() {

      var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPdJ,
          this.pessoaMap.credorInfoCad.checarParametrosAoGerarAcordo, this.pessoa2);

      if (pessoaDados.valor == '') {
          pessoaDados.valor = 'Nao';
      }

      if (pessoaDados.valor === 'Sim') {
          return true;
      }
      return false;


  }






    handleChangeCalcularHonorarios(evt, tipo) {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.taxaAdministrativa, this.pessoa2);

        var target = evt.target;
        if (tipo == 'Sim') {
            this.calcularHonorarios = true;


        }
        if (tipo == 'Não') {
            this.calcularHonorarios = false;
            pessoaDados.valor = '0';
            //this.pessoa.cliente.taxaAdministrativa.valor = '0';
        }

    }

    checkTaxaAdministrativa() {

        var pessoaDados = this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,
            this.pessoaMap.credorInfoCad.taxaAdministrativa, this.pessoa2);

        if (pessoaDados.valor != '0' && pessoaDados.valor != '') {
            return true;
        }
        return false;

        // if (this.pessoa.cliente.taxaAdministrativa.valor != '0') {
        //     return true;
        // } else {
        //     false;
        // }
    }


    getValue(chavePessoaDados: String, chavePessoaComplementar, pessoa: Pessoa) {

        var pessoaDados = this.pessoa2.pessoaDados.find(x => x.nome == chavePessoaDados);

        if (pessoaDados != null) {
            var pessoaDadosComplementares = pessoaDados.pessoaDadosComplementares.find(x => x.nome == chavePessoaComplementar);

            if (pessoaDadosComplementares != null) {
                return pessoaDadosComplementares;
            } else {
                var newPessoaDadosComp = new PessoaDadosComplementares();
                newPessoaDadosComp.pessoaDadosId = pessoaDados.id;
                newPessoaDadosComp.nome = chavePessoaComplementar;

                pessoaDados.pessoaDadosComplementares.push(newPessoaDadosComp);

                return newPessoaDadosComp;
            }


        }
        else {
            
            var newPessoaDados = new PessoaDados();
            newPessoaDados.nome = chavePessoaDados;

            var newPessoaDadosComp = new PessoaDadosComplementares();
            newPessoaDadosComp.pessoaDadosId = newPessoaDados.id;
            newPessoaDadosComp.nome = chavePessoaComplementar;

            newPessoaDados.pessoaDadosComplementares.push(newPessoaDadosComp);

            this.pessoa2.pessoaDados.push(newPessoaDados);

            return newPessoaDadosComp;

        }



    }


    getListValue(chavePessoaDados: String, pessoa: Pessoa) {
        var pessoaDados = this.pessoa2.pessoaDados.filter(function getListValues(element, index, array) {
            return element.nome == chavePessoaDados;
        });

        if (pessoaDados != null) {
            return pessoaDados;
        }

    }

    getDadoCompNg2(chaveComplementar: String, pdc: PessoaDados) {
        if (pdc.pessoaDadosComplementares != undefined) {
            var pessoaDadosComplementares = pdc.pessoaDadosComplementares.find(x => x.nome == chaveComplementar);

            if (pessoaDadosComplementares != null) {
                return pessoaDadosComplementares;
            }
        }


        var pessoaDadosComplementar = new PessoaDadosComplementares();
        pessoaDadosComplementar.nome = chaveComplementar;
        pessoaDadosComplementar.valor = "";
        pessoaDadosComplementar.pessoaDadosId = pdc.id != null ? pdc.id : undefined;

        return pessoaDadosComplementar;

    }


    startTableNgBanco(pessoaDados: PessoaDados[], dadosTableNG: any[]) {
        pessoaDados.forEach(x => {
            var nomeBanco = this.getDadoCompNg2(this.pessoaMap.banco.nomeBanco, x).valor;
            var nomeBancoId = this.getDadoCompNg2(this.pessoaMap.banco.nomeBanco, x).id;
            var agencia = this.getDadoCompNg2(this.pessoaMap.banco.agencia, x).valor;
            var agenciaId = this.getDadoCompNg2(this.pessoaMap.banco.agencia, x).id;
            var contato = this.getDadoCompNg2(this.pessoaMap.banco.contato, x).valor;
            var contatoId = this.getDadoCompNg2(this.pessoaMap.banco.contato, x).id;
            var contaCorrente = this.getDadoCompNg2(this.pessoaMap.banco.contaCorrente, x).valor;
            var contaCorrenteId = this.getDadoCompNg2(this.pessoaMap.banco.contaCorrente, x).id;
            var pessoaDadosId = x.id;
            dadosTableNG.push({
                nomeBanco: nomeBanco,
                nomeBancoId: nomeBancoId,
                agencia: agencia,
                agenciaId: agenciaId,
                contato: contato,
                contatoId: contatoId,
                contaCorrente: contaCorrente,
                contaCorrrenteId: contaCorrenteId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    refreshBancoPessoa() {

        this.bancosPessoa = [];
        this.pessoa2.pessoaDados = this.pessoa2.pessoaDados.filter(obj => obj.nome != this.pessoaMap.banco.bancoPd);

        this.bancosPessoaNG.forEach(x => {

            var pdcNomeBanco = new PessoaDadosComplementares();
            pdcNomeBanco.valor = x.nomeBanco,
                pdcNomeBanco.nome = this.pessoaMap.banco.nomeBanco;
            pdcNomeBanco.id = x.nomeBancoId,
                pdcNomeBanco.pessoaDadosId = x.pessoaDadosId;

            var pdcAgencia = new PessoaDadosComplementares();
            pdcAgencia.valor = x.agencia,
                pdcAgencia.nome = this.pessoaMap.banco.agencia;
            pdcAgencia.id = x.agenciaId,
                pdcAgencia.pessoaDadosId = x.pessoaDadosId;

            var pdcContato = new PessoaDadosComplementares();
            pdcContato.valor = x.contato,
                pdcContato.nome = this.pessoaMap.banco.contato;
            pdcContato.id = x.contatoId,
                pdcContato.pessoaDadosId = x.pessoaDadosId;

            var pdcContaCorrente = new PessoaDadosComplementares();
            pdcContaCorrente.valor = x.contaCorrente,
                pdcContaCorrente.nome = this.pessoaMap.banco.contaCorrente;
            pdcContaCorrente.id = x.contaCorrenteId,
                pdcContaCorrente.pessoaDadosId = x.pessoaDadosId;

            var pd = new PessoaDados();
            pd.nome = this.pessoaMap.banco.bancoPd,
                pd.valor = "";
            pd.pessoaId = this.pessoa2.id,
                pd.id = x.pessoaDadosId;

            pd.pessoaDadosComplementares.push(pdcNomeBanco);
            pd.pessoaDadosComplementares.push(pdcAgencia);
            pd.pessoaDadosComplementares.push(pdcContato);
            pd.pessoaDadosComplementares.push(pdcContaCorrente);

            this.bancosPessoa.push(pd);
        });
    }


    startTableNgTelefone(pessoaDados: PessoaDados[], dadosTableNG: any[]) {

        pessoaDados.forEach(x => {
            var tipoTelefone = this.getDadoCompNg2(this.pessoaMap.telefone.tipo, x).valor;
            var tipoTelefoneId = this.getDadoCompNg2(this.pessoaMap.telefone.tipo, x).id;
            var numero = this.getDadoCompNg2(this.pessoaMap.telefone.numero, x).valor;
            var numeroId = this.getDadoCompNg2(this.pessoaMap.telefone.numero, x).id;
            var ramal = this.getDadoCompNg2(this.pessoaMap.telefone.ramal, x).valor;
            var ramalId = this.getDadoCompNg2(this.pessoaMap.telefone.ramal, x).id;
            var contato = this.getDadoCompNg2(this.pessoaMap.telefone.contato, x).valor;
            var contatoId = this.getDadoCompNg2(this.pessoaMap.telefone.contato, x).id;
            var email = this.getDadoCompNg2(this.pessoaMap.telefone.email, x).valor;
            var emailId = this.getDadoCompNg2(this.pessoaMap.telefone.email, x).id;
            var departamento = this.getDadoCompNg2(this.pessoaMap.telefone.departamento, x).valor;
            var departamentoId = this.getDadoCompNg2(this.pessoaMap.telefone.departamento, x).id;
            var pessoaDadosId = x.id;
            dadosTableNG.push({
                tipoTelefone: tipoTelefone,
                tipoTelefoneId: tipoTelefoneId,
                numero: numero,
                numeroId: numeroId,
                ramal: ramal,
                ramalId: ramalId,
                contato: contato,
                contatoId: contatoId,
                email: email,
                emailId: emailId,
                departamento: departamento,
                departamentoId: departamentoId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    refreshTelefonePessoa() {

        this.telefonesPessoa = [];
        this.pessoa2.pessoaDados = this.pessoa2.pessoaDados.filter(obj => obj.nome != this.pessoaMap.telefone.telefonePd);

        this.telefonesPessoaNG.forEach(x => {

            var pdcTipoTelefone = new PessoaDadosComplementares();
            pdcTipoTelefone.valor = x.tipoTelefone,
                pdcTipoTelefone.nome = this.pessoaMap.telefone.tipo;
            pdcTipoTelefone.id = x.tipoTelefoneId,
                pdcTipoTelefone.pessoaDadosId = x.pessoaDadosId;

            var pdcNumero = new PessoaDadosComplementares();
            pdcNumero.valor = x.numero,
                pdcNumero.nome = this.pessoaMap.telefone.numero;
            pdcNumero.id = x.numeroId,
                pdcNumero.pessoaDadosId = x.pessoaDadosId;

            var pdcRamal = new PessoaDadosComplementares();
            pdcRamal.valor = x.ramal,
                pdcRamal.nome = this.pessoaMap.telefone.ramal;
            pdcRamal.id = x.ramalId,
                pdcRamal.pessoaDadosId = x.pessoaDadosId;

            var pdcContato = new PessoaDadosComplementares();
            pdcContato.valor = x.contato,
                pdcContato.nome = this.pessoaMap.telefone.contato;
            pdcContato.id = x.contatoId,
                pdcContato.pessoaDadosId = x.pessoaDadosId;

            var pdcEmail = new PessoaDadosComplementares();
            pdcEmail.valor = x.email,
                pdcEmail.nome = this.pessoaMap.telefone.email;
            pdcEmail.id = x.emailId,
                pdcEmail.pessoaDadosId = x.pessoaDadosId;

            var pdcDepartamento = new PessoaDadosComplementares();
            pdcDepartamento.valor = x.departamento,
                pdcDepartamento.nome = this.pessoaMap.telefone.departamento;
            pdcDepartamento.id = x.departamentoId,
                pdcDepartamento.pessoaDadosId = x.pessoaDadosId;



            var pd = new PessoaDados();
            pd.nome = this.pessoaMap.telefone.telefonePd,
                pd.valor = "";
            pd.pessoaId = this.pessoa2.id,
                pd.id = x.pessoaDadosId;

            pd.pessoaDadosComplementares.push(pdcTipoTelefone);
            pd.pessoaDadosComplementares.push(pdcNumero);
            pd.pessoaDadosComplementares.push(pdcRamal);
            pd.pessoaDadosComplementares.push(pdcContato);
            pd.pessoaDadosComplementares.push(pdcEmail);
            pd.pessoaDadosComplementares.push(pdcDepartamento);

            this.telefonesPessoa.push(pd);
        });
    }



    startTableNgTelefoneDevedor(pessoaDados: PessoaDados[], dadosTableNG: any[]) {

        pessoaDados.forEach(x => {
            var tipoTelefone = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.tipo, x).valor;
            var tipoTelefoneId = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.tipo, x).id;
            var numero = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.numero, x).valor;
            var numeroId = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.numero, x).id;
            var ramal = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.ramal, x).valor;
            var ramalId = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.ramal, x).id;
            var contato = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.contato, x).valor;
            var contatoId = this.getDadoCompNg2(this.pessoaMap.telefoneDevedor.contato, x).id;
            var pessoaDadosId = x.id;
            dadosTableNG.push({
                tipoTelefone: tipoTelefone,
                tipoTelefoneId: tipoTelefoneId,
                numero: numero,
                numeroId: numeroId,
                ramal: ramal,
                ramalId: ramalId,
                contato: contato,
                contatoId: contatoId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    startTableNgEnderecos(pessoaDados: PessoaDados[], dadosTableNG: any[]) {
        pessoaDados.forEach(x => {
            var uf = this.getDadoCompNg2(this.pessoaMap.endereco.uf, x).valor;
            var ufId = this.getDadoCompNg2(this.pessoaMap.endereco.uf, x).id;
            var cidade = this.getDadoCompNg2(this.pessoaMap.endereco.cidade, x).valor;
            var cidadeId = this.getDadoCompNg2(this.pessoaMap.endereco.cidade, x).id;
            var cep = this.getDadoCompNg2(this.pessoaMap.endereco.cep, x).valor;
            var cepId = this.getDadoCompNg2(this.pessoaMap.endereco.cep, x).id;
            var logradouro = this.getDadoCompNg2(this.pessoaMap.endereco.logradouro, x).valor;
            var logradouroId = this.getDadoCompNg2(this.pessoaMap.endereco.logradouro, x).id;
            var pessoaDadosId = x.id;
            dadosTableNG.push({
                uf: uf,
                ufId: ufId,
                cidade: cidade,
                cidadeId: cidadeId,
                cep: cep,
                cepId: cepId,
                logradouro: logradouro,
                logradouroId: logradouroId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    refreshEnderecosPessoa() {

        this.enderecosPessoa = [];
        this.pessoa2.pessoaDados = this.pessoa2.pessoaDados.filter(obj => obj.nome != this.pessoaMap.endereco.enderecoPd);

        this.enderecosPessoaNG.forEach(x => {

            var pdcUf = new PessoaDadosComplementares();
            pdcUf.valor = x.uf,
                pdcUf.nome = this.pessoaMap.endereco.uf;
            pdcUf.id = x.ufId,
                pdcUf.pessoaDadosId = x.pessoaDadosId;

            var pdcCidade = new PessoaDadosComplementares();
            pdcCidade.valor = x.cidade,
                pdcCidade.nome = this.pessoaMap.endereco.cidade;
            pdcCidade.id = x.cidadeId,
                pdcCidade.pessoaDadosId = x.pessoaDadosId;

            var pdcCep = new PessoaDadosComplementares();
            pdcCep.valor = x.cep,
                pdcCep.nome = this.pessoaMap.endereco.cep;
            pdcCep.id = x.cepId,
                pdcCep.pessoaDadosId = x.pessoaDadosId;

            var pdcLogradouro = new PessoaDadosComplementares();
            pdcLogradouro.valor = x.logradouro,
                pdcLogradouro.nome = this.pessoaMap.endereco.logradouro;
            pdcLogradouro.id = x.logradouroId,
                pdcLogradouro.pessoaDadosId = x.pessoaDadosId;



            var pd = new PessoaDados();
            pd.nome = this.pessoaMap.endereco.enderecoPd,
                pd.valor = "";
            pd.pessoaId = this.pessoa2.id,
                pd.id = x.pessoaDadosId;

            pd.pessoaDadosComplementares.push(pdcUf);
            pd.pessoaDadosComplementares.push(pdcCidade);
            pd.pessoaDadosComplementares.push(pdcCep);
            pd.pessoaDadosComplementares.push(pdcLogradouro);


            this.enderecosPessoa.push(pd);
        });
    }

    startTableNgComissoesCobrador(pessoaDados: PessoaDados[], dadosTableNG: any[]) {

        pessoaDados.forEach(x => {
            var percentual = this.getDadoCompNg2(this.pessoaMap.cobradorComissao.percentual, x).valor;
            var percentualId = this.getDadoCompNg2(this.pessoaMap.cobradorComissao.percentual, x).id;
            var tipoCobrador = this.getDadoCompNg2(this.pessoaMap.cobradorComissao.tipo, x).valor;
            var tipoCobradorId = this.getDadoCompNg2(this.pessoaMap.cobradorComissao.tipo, x).id;

            var pessoaDadosId = x.id;
            dadosTableNG.push({
                percentual: percentual,
                percentualId: percentualId,
                tipoCobrador: tipoCobrador,
                tipoCobradorId: tipoCobradorId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    refreshComissoesCobradorPessoa() {

        this.comissoesCobradorPessoa = [];
        this.pessoa2.pessoaDados = this.pessoa2.pessoaDados.filter(obj => obj.nome != this.pessoaMap.cobradorComissao.cobradorComissaoPd);

        this.comissoesCobradorPessoaNG.forEach(x => {

            var pdcPercentual = new PessoaDadosComplementares();
            pdcPercentual.valor = x.percentual,
                pdcPercentual.nome = this.pessoaMap.cobradorComissao.percentual;
            pdcPercentual.id = x.percentualId,
                pdcPercentual.pessoaDadosId = x.pessoaDadosId;

            var pdcTipoCobrador = new PessoaDadosComplementares();
            pdcTipoCobrador.valor = x.tipoCobrador,
                pdcTipoCobrador.nome = this.pessoaMap.cobradorComissao.tipo;
            pdcTipoCobrador.id = x.tipoCobradorId,
                pdcTipoCobrador.pessoaDadosId = x.pessoaDadosId;

            var pd = new PessoaDados();
            pd.nome = this.pessoaMap.cobradorComissao.cobradorComissaoPd,
                pd.valor = "";
            pd.pessoaId = this.pessoa2.id,
                pd.id = x.pessoaDadosId;

            pd.pessoaDadosComplementares.push(pdcPercentual);
            pd.pessoaDadosComplementares.push(pdcTipoCobrador);

            this.comissoesCobradorPessoa.push(pd);
        });
    }


    startTableNgAdicionais(pessoaDados: PessoaDados[], dadosTableNG: any[]) {

        pessoaDados.forEach(x => {
            var campo = this.getDadoCompNg2(this.pessoaMap.adicional.campo, x).valor;
            var campoId = this.getDadoCompNg2(this.pessoaMap.adicional.campo, x).id;

            var conteudo = this.getDadoCompNg2(this.pessoaMap.adicional.conteudo, x).valor;
            var conteudoId = this.getDadoCompNg2(this.pessoaMap.adicional.conteudo, x).id;

            var pessoaDadosId = x.id;
            dadosTableNG.push({
                campo: campo,
                campoId: campoId,
                conteudo: conteudo,
                conteudoId: conteudoId,
                pessoaDadosId: pessoaDadosId,
            });
        });
    }

    refreshAdicionaisPessoa() {

        this.camposAdicionaisPessoa = [];
        this.pessoa2.pessoaDados = this.pessoa2.pessoaDados.filter(obj => obj.nome != this.pessoaMap.adicional.adicionalPd);

        this.camposAdicionaisPessoaNG.forEach(x => {

            var pdcCampo = new PessoaDadosComplementares();
            pdcCampo.valor = x.campo,
                pdcCampo.nome = this.pessoaMap.adicional.campo;
            pdcCampo.id = x.campoId,
                pdcCampo.pessoaDadosId = x.pessoaDadosId;

            var pdcConteudo = new PessoaDadosComplementares();
            pdcConteudo.valor = x.conteudo,
                pdcConteudo.nome = this.pessoaMap.adicional.conteudo;
            pdcConteudo.id = x.conteudoId,
                pdcConteudo.pessoaDadosId = x.pessoaDadosId;


            var pd = new PessoaDados();
            pd.nome = this.pessoaMap.adicional.adicionalPd,
                pd.valor = "";
            pd.pessoaId = this.pessoa2.id,
                pd.id = x.pessoaDadosId;

            pd.pessoaDadosComplementares.push(pdcCampo);
            pd.pessoaDadosComplementares.push(pdcConteudo);

            this.camposAdicionaisPessoa.push(pd);
        });
    }


    startLists() {
        this.bancosPessoa = this.getListValue(this.pessoaMap.banco.bancoPd, this.pessoa2);
        this.telefonesPessoa = this.getListValue(this.pessoaMap.telefone.telefonePd, this.pessoa2);
        this.camposAdicionaisPessoa = this.getListValue(this.pessoaMap.adicional.adicionalPd, this.pessoa2);
        this.comissoesCobradorPessoa = this.getListValue(this.pessoaMap.cobradorComissao.cobradorComissaoPd, this.pessoa2);
        this.enderecosPessoa = this.getListValue(this.pessoaMap.endereco.enderecoPd, this.pessoa2);

        this.startTableNgBanco(this.bancosPessoa, this.bancosPessoaNG);
        this.startTableNgTelefone(this.telefonesPessoa, this.telefonesPessoaNG);
        this.startTableNgEnderecos(this.enderecosPessoa, this.enderecosPessoaNG);

        this.startTableNgComissoesCobrador(this.comissoesCobradorPessoa, this.comissoesCobradorPessoaNG);
        this.startTableNgAdicionais(this.camposAdicionaisPessoa, this.camposAdicionaisPessoaNG);
    }



    addLists() {
        this.refreshBancoPessoa();
        this.pessoa2.pessoaDados.push.apply(this.pessoa2.pessoaDados, this.bancosPessoa);

        this.refreshTelefonePessoa();
        this.pessoa2.pessoaDados.push.apply(this.pessoa2.pessoaDados, this.telefonesPessoa);

        this.refreshEnderecosPessoa();
        this.pessoa2.pessoaDados.push.apply(this.pessoa2.pessoaDados, this.enderecosPessoa);

        this.refreshComissoesCobradorPessoa();
        this.pessoa2.pessoaDados.push.apply(this.pessoa2.pessoaDados, this.comissoesCobradorPessoa);

        this.refreshAdicionaisPessoa();
        this.pessoa2.pessoaDados.push.apply(this.pessoa2.pessoaDados, this.camposAdicionaisPessoa);

    }

    //auto complete grupo
    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 1 ? []
                : this.dadosUnico.filter(v => v.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1))
        )

    onDownloadFile(event) {
        var fileId = event.data.id;

        this.pessoaService.downloadArquivo(fileId).subscribe(
            data => {
                this.utilsService.renderDownload(data, event.data.nome as string);
            }
        );
    }

    avisoPessoDeletada() {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-padrao btn-lg mr-3',
                cancelButton: 'btn btn-default btn-lg'
            },
            buttonsStyling: false
        });

        swalWithBootstrapButtons.fire({
            text: 'Essa pessoa foi deletada!',
            confirmButtonColor: '#FFD950 !important;',
            showCloseButton: true,
            icon: 'warning',
            confirmButtonText: 'Ok',
        }).then((result) => {
            this.close();
        });
    }

    async checkPessoaIfExists(pessoaId) {
        this.pessoaService.checkIfExists(pessoaId).then(x => {
            if (x["data"].length == 0) {
                this.avisoPessoDeletada();
            }
        });
    }

    public valorSalario: string;

    calcularSalario(){
        const quantidade:number = +this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,this.pessoaMap.credorInfoCad.initialFeeSalariosPrivado,this.pessoa2).valor;

        this.valorSalario = formatarValorParaReal(quantidade * this.valorSalarioCorrente);
    }

    public valorSalarioPublico: string;

    calcularSalarioPublico(){
        const quantidade:number = +this.getValue(this.pessoaMap.credorInfoCad.credorInfoCadPd,this.pessoaMap.credorInfoCad.initialFeeSalariosPublico,this.pessoa2).valor;

        this.valorSalarioPublico = formatarValorParaReal(quantidade * this.valorSalarioCorrente);
    }

    private _definirTituloModal() {
        this.tituloModal = `${this.modalRef.componentInstance.updateData ? 'Atualizar' : 'Cadastrar'} pessoa`;
    }

    //TODO: Isso estava no onChangeTipoPessoa, entender e ajustar conforme necessidade
    private _carregarDadosIniciais(){
        if (!this.modalRef.componentInstance.updateData) {
            this.politicaDeAcordoDefault();
            this.politicaDeAcordoDefaultJuridico();
        }

         this.checks();
    }

    private _verificarModoSomenteLeitura() {
        this.modoSomenteLeitura = !this.authService.isMaster() && this.pessoa2 != null;
    }

    private _validarDocumentosAnexados(): boolean {

        if(this.uploader?.queue?.length == 0 ?? 0)
            return true;

        var arquivos = [];
        this.uploader.queue.forEach(x => {
            const file = x.file as CustomFileLike;
            arquivos.push(file);
        });

        var validacao = arquivos.find(x => x.documentType == Guid.EMPTY);
        if (validacao != null || validacao != undefined) {
            this.toastrService.error('Selecione um tipo de documento valido.', 'Erro');
            return false;
        }
    }

    handleChangeCategoriaPessoaJuridica() : void {
        if(!this.informaDocumento)
            this.pessoa2.cpfCnpj = null;
    }

    handleChangeNaturezaPessoa(): void {
        if(!this.informaUnidadeNegocioInformacaoCadastro && this.pessoa2.unidadeNegocioId)
            this.pessoa2.unidadeNegocioId = null;

        if(!this.informaGrupoInformacaoCadastro && this.pessoa2.grupoId)
            this.pessoa2.grupoId = null;
    }

    definirnaturezaPessoa(naturezaPessoa:NaturezaPessoa){
        debugger;
        this.pessoa2.naturezaPessoa = naturezaPessoa;
    }

    private _popularDropdownsPessoasPorCategorias() {
        const categoriasComDropdown = [CategoriaPessoaJuridica.UnidadeNegocio, CategoriaPessoaJuridica.Grupo];
        this.pessoaService.listarPessoasPorCategoriasPessoaJuridica(categoriasComDropdown)
        .subscribe(result => {
            const dados = result.data;
            this.listaUnidadesNegocio = dados.filter(x => x.categoriaPessoaJuridica == CategoriaPessoaJuridica.UnidadeNegocio);
            this.listaGrupos = dados.filter(x => x.categoriaPessoaJuridica == CategoriaPessoaJuridica.Grupo);
        }, error => {
            if (error && error.errors) {
                error.errors.forEach(element => {
                    this.toastrService.error(element, 'Atenção', { timeOut: 10000 });
                });
            } else {
                this.toastrService.error('Não foi possível obter pessoas por categoria PJ', 'Atenção', { timeOut: 10000 });
            }
            this.spinner.hide();
        });
    }
}

class CustomFileLike extends FileLikeObject {
    public documentType: string;
}
